export const topicsData = [
  { id: 't1', tag: '91视频', label: '热门推荐', heat: '128.6万', desc: '91视频网站每日更新精选，高清资源一网打尽' },
  { id: 't2', tag: '久久视频', label: '新番上线', heat: '96.3万', desc: '久久视频专区最新剧集，全集免费在线观看' },
  { id: 't3', tag: '91在线视频', label: '热播中', heat: '87.1万', desc: '91在线视频实时更新，不缓冲流畅播放体验' },
  { id: 't4', tag: '电视剧全集', label: '持续更新', heat: '75.8万', desc: '电视剧全集资源库，热门剧集一键追更' },
  { id: 't5', tag: '电影大全', label: '本周热门', heat: '68.4万', desc: '电影大全分类导航，院线大片经典老片一站收' },
  { id: 't6', tag: '不缓冲', label: '技术保障', heat: '62.1万', desc: '不缓冲播放技术，全网加速观影体验' },
  { id: 't7', tag: '高清免费', label: '品质之选', heat: '55.7万', desc: '高清免费在线观看，画质与速度兼得' },
  { id: 't8', tag: '最新影视', label: '每日更新', heat: '49.2万', desc: '最新影视资源第一时间同步，追剧不等待' },
  { id: 't9', tag: '热门剧集', label: '口碑推荐', heat: '43.8万', desc: '热门剧集排行榜，全网口碑好剧一网打尽' },
  { id: 't10', tag: '午夜剧场', label: '深夜精选', heat: '38.5万', desc: '深夜观影精选推荐，陪你度过每一个夜晚' },
];

export const cardsData = [
  {
    id: 'c1',
    title: '91视频网站高清专区全面升级',
    summary: '91视频网站高清专区已完成全面升级，新增4K超清频道和智能推荐算法，为你精准匹配最爱看的视频内容。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20home%20theater%20setup%20with%20large%20screen%20displaying%20cinematic%20content%2C%20warm%20ambient%20lighting%2C%20cozy%20living%20room%20atmosphere%2C%20entertainment%20focused%2C%20rich%20dark%20tones%20with%20gold%20accents%2C%20premium%20viewing%20experience%2C%20soft%20glow%20from%20screen%2C%20comfortable%20seating&width=800&height=500&seq=rose-card-01&orientation=landscape',
    tag: '平台动态',
    date: '2026-07-30',
  },
  {
    id: 'c2',
    title: '久久视频七月片单：十部必看佳片',
    summary: '久久视频为你精心挑选七月最值得观看的十部影视作品，涵盖动作、悬疑、爱情多种类型，全集免费在线观看不缓冲。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20film%20reel%20and%20movie%20posters%20arranged%20artistically%20on%20a%20dark%20wall%2C%20cinematic%20atmosphere%2C%20vintage%20movie%20theater%20aesthetic%2C%20warm%20spotlight%20illumination%2C%20rich%20burgundy%20and%20gold%20color%20palette%2C%20classic%20hollywood%20vibe&width=800&height=500&seq=rose-card-02&orientation=landscape',
    tag: '片单推荐',
    date: '2026-07-28',
  },
  {
    id: 'c3',
    title: '91在线视频播放器技术解析：为何不缓冲',
    summary: '深入了解91在线视频背后的流媒体加速技术，从CDN节点部署到智能码率自适应，揭秘不缓冲流畅播放的核心秘密。',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20data%20center%20with%20server%20racks%20and%20glowing%20network%20connections%2C%20technology%20infrastructure%2C%20cool%20blue%20and%20warm%20amber%20indicator%20lights%2C%20high%20tech%20atmosphere%2C%20digital%20streaming%20concept%2C%20clean%20professional%20environment&width=800&height=500&seq=rose-card-03&orientation=landscape',
    tag: '技术解析',
    date: '2026-07-26',
  },
  {
    id: 'c4',
    title: '电视剧全集追更日历：八月新剧前瞻',
    summary: '最新影视剧集上线时间表一览，电视剧全集追更不迷路。玫瑰视频持续同步更新，让你第一时间看到心仪剧集。',
    image: 'https://readdy.ai/api/search-image?query=Stylish%20calendar%20and%20planner%20with%20film%20strip%20elements%20on%20a%20desk%2C%20creative%20workspace%2C%20warm%20desk%20lamp%20lighting%2C%20coffee%20cup%2C%20notebook%20with%20handwritten%20notes%2C%20cinematic%20mood%2C%20organized%20yet%20artistic%20composition&width=800&height=500&seq=rose-card-04&orientation=landscape',
    tag: '追更日历',
    date: '2026-07-25',
  },
  {
    id: 'c5',
    title: '电影大全分类导览：快速找到你想看的',
    summary: '电影大全涵盖动作、喜剧、科幻、恐怖等十余种分类，配合智能搜索和标签系统，让你在海量影片中迅速锁定目标。',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20movie%20genre%20icons%20and%20categories%20displayed%20on%20a%20dark%20interface%2C%20organized%20grid%20layout%2C%20modern%20UI%20design%20concept%2C%20vibrant%20yet%20sophisticated%20color%20accents%2C%20digital%20entertainment%20platform%20aesthetic&width=800&height=500&seq=rose-card-05&orientation=landscape',
    tag: '分类导览',
    date: '2026-07-23',
  },
  {
    id: 'c6',
    title: '玫瑰视频用户年度观影报告即将发布',
    summary: '2026上半年度观影数据报告即将出炉，看看全网用户都在91视频网站和久久视频上看什么，热门趋势一图读懂。',
    image: 'https://readdy.ai/api/search-image?query=Data%20visualization%20dashboard%20with%20charts%20and%20graphs%20showing%20entertainment%20trends%2C%20dark%20theme%20interface%2C%20colorful%20data%20points%2C%20modern%20analytics%20design%2C%20cinematic%20color%20grading%2C%20professional%20presentation%20style&width=800&height=500&seq=rose-card-06&orientation=landscape',
    tag: '年度报告',
    date: '2026-07-20',
  },
];

export const carouselData = [
  {
    id: 'cr1',
    title: '暑期档必看：十部高分华语电影',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20collage%20featuring%20dramatic%20scenes%20from%20Chinese%20films%2C%20warm%20golden%20and%20crimson%20color%20palette%2C%20artistic%20composition%2C%20film%20strip%20borders%2C%20premium%20movie%20poster%20aesthetic%2C%20rich%20textures%2C%20dramatic%20lighting&width=1200&height=600&seq=rose-carousel-01&orientation=landscape',
    tag: '专题合集',
    desc: '从经典修复到新片速递，玫瑰视频为你精选暑期最值得观看的十部华语电影，高清免费在线观看，不缓冲畅享。',
  },
  {
    id: 'cr2',
    title: '91视频网站热门剧集TOP20',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20television%20series%20scenes%20montage%20with%20intense%20character%20expressions%2C%20warm%20lighting%2C%20cinematic%20color%20grading%2C%20emotional%20storytelling%20moments%2C%20premium%20TV%20show%20production%20quality%2C%20rich%20dark%20background&width=1200&height=600&seq=rose-carousel-02&orientation=landscape',
    tag: '热播榜单',
    desc: '基于全网播放数据和用户口碑，实时更新的91视频网站剧集排行榜。久久视频同步更新，全集追更不迷路。',
  },
  {
    id: 'cr3',
    title: '深夜影院：悬疑惊悚特辑',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20atmospheric%20scene%20with%20fog%20and%20shadows%2C%20film%20noir%20aesthetic%2C%20dramatic%20lighting%20through%20venetian%20blinds%2C%20suspenseful%20mood%2C%20dark%20cinematic%20photography%2C%20rich%20contrast%2C%20vintage%20detective%20vibe&width=1200&height=600&seq=rose-carousel-03&orientation=landscape',
    tag: '类型专场',
    desc: '91在线视频精选悬疑惊悚佳作，从心理恐怖到连环谜案，让你在深夜体验极致观影紧张感，电影大全持续扩充。',
  },
  {
    id: 'cr4',
    title: '经典回顾：港片黄金年代',
    image: 'https://readdy.ai/api/search-image?query=Nostalgic%20Hong%20Kong%20street%20scene%20with%20neon%20signs%20and%20classic%20cinema%20posters%2C%20warm%20vintage%20tones%2C%20rain%20slicked%20streets%2C%20retro%20movie%20theater%20marquee%2C%20golden%20age%20film%20aesthetic%2C%20atmospheric%20night%20scene&width=1200&height=600&seq=rose-carousel-04&orientation=landscape',
    tag: '经典回顾',
    desc: '重温港片黄金年代的不朽经典，从武侠到警匪，最新影视修复版高清上线，电视剧全集一网打尽。',
  },
  {
    id: 'cr5',
    title: '国漫崛起：国产动画精选',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20animation%20art%20style%2C%20ink%20wash%20painting%20aesthetic%20blended%20with%20modern%20digital%20art%2C%20fantasy%20landscapes%2C%20flowing%20fabric%20and%20dynamic%20composition%2C%20rich%20traditional%20colors%2C%20epic%20scale&width=1200&height=600&seq=rose-carousel-05&orientation=landscape',
    tag: '国漫精选',
    desc: '国产动画精品佳作持续收录，从水墨风到3D大作，玫瑰视频高清在线观看，免费完整版不缓冲播放。',
  },
  {
    id: 'cr6',
    title: '纪录片天地：真实的力量',
    image: 'https://readdy.ai/api/search-image?query=Stunning%20nature%20and%20wildlife%20documentary%20scene%2C%20majestic%20landscapes%20with%20dramatic%20skies%2C%20cinematic%20aerial%20photography%2C%20rich%20natural%20colors%2C%20planet%20earth%20style%20visuals%2C%20breathtaking%20vistas&width=1200&height=600&seq=rose-carousel-06&orientation=landscape',
    tag: '纪录片',
    desc: '从自然奇观到人文探秘，电影大全纪录片专区为你打开真实世界的窗口，高清画质呈现每一个震撼瞬间。',
  },
];

export const contactData = {
  title: '投稿与合作',
  intro: '玫瑰视频始终欢迎优质内容创作者和合作伙伴加入我们。无论你是独立导演、影视解说UP主，还是内容授权方，都可以通过以下方式与我们取得联系。91视频网站、久久视频、91在线视频等频道的合作咨询均由此统一受理。',
  email: 'contact@meiguivideo.com',
  wechat: 'meiguivideo_official',
  qq: '800123456',
  hours: '工作日 9:00 - 18:00',
};

export const commentsData = [
  {
    id: 'cm1',
    user: '电影爱好者小王',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Chinese%20man%2C%20friendly%20expression%2C%20casual%20style%2C%20warm%20lighting%2C%20clean%20background%2C%20professional%20headshot&width=80&height=80&seq=rose-avatar-01&orientation=squarish',
    text: '用了玫瑰视频大半年了，91视频网站的资源更新速度真的快，基本上热门剧集当天就能看到。高清画质配上不缓冲的播放体验，追剧体验直线上升！',
    date: '2026-07-29',
    rating: 5,
  },
  {
    id: 'cm2',
    user: '追剧达人小陈',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Chinese%20woman%20with%20glasses%2C%20warm%20smile%2C%20casual%20outfit%2C%20soft%20lighting%2C%20clean%20white%20background%2C%20professional%20headshot&width=80&height=80&seq=rose-avatar-02&orientation=squarish',
    text: '久久视频的电视剧全集功能太实用了，再也不用到处找资源了。分类清晰、更新及时，还有追更提醒，简直是剧迷的天堂！',
    date: '2026-07-28',
    rating: 5,
  },
  {
    id: 'cm3',
    user: '技术宅阿强',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20tech%20enthusiast%20Chinese%20man%2C%20confident%20expression%2C%20modern%20style%2C%20neutral%20studio%20lighting%2C%20clean%20background%2C%20professional%20headshot&width=80&height=80&seq=rose-avatar-03&orientation=squarish',
    text: '作为程序员，我必须夸一下91在线视频的播放器技术。自适应码率做得很好，4G网络下也能流畅播放，真的做到了不缓冲的承诺。',
    date: '2026-07-27',
    rating: 4,
  },
  {
    id: 'cm4',
    user: '深夜观影爱好者',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20creative%20Chinese%20person%20with%20artistic%20style%2C%20thoughtful%20expression%2C%20dim%20warm%20lighting%2C%20clean%20background%2C%20editorial%20portrait&width=80&height=80&seq=rose-avatar-04&orientation=squarish',
    text: '电影大全的专题策划很有深度，不是简单的列表堆砌。每期专题都能发现一些冷门好片，电影爱好者表示非常满足！',
    date: '2026-07-26',
    rating: 5,
  },
  {
    id: 'cm5',
    user: '宝妈追剧人',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20warm%20smiling%20Chinese%20woman%20in%20her%2030s%2C%20friendly%20expression%2C%20casual%20home%20style%2C%20soft%20natural%20light%2C%20clean%20background%2C%20lifestyle%20portrait&width=80&height=80&seq=rose-avatar-05&orientation=squarish',
    text: '在家带娃的间隙追剧，玫瑰视频的高清免费在线观看简直救了我的命。最新影视更新快，不用等广告，碎片时间也能完整追完一部剧。',
    date: '2026-07-25',
    rating: 5,
  },
];

export const featuresData = [
  {
    id: 'f1',
    icon: 'ri-4k-line',
    title: '高清画质',
    desc: '91视频网站全线资源支持1080P至4K超高清画质，为你呈现每一个精彩细节，打造沉浸式观影体验。',
  },
  {
    id: 'f2',
    icon: 'ri-speed-up-line',
    title: '不缓冲播放',
    desc: '自研流媒体加速引擎配合全国CDN节点部署，91在线视频实现秒开不缓冲，告别卡顿等待。',
  },
  {
    id: 'f3',
    icon: 'ri-film-line',
    title: '海量资源',
    desc: '久久视频与电影大全聚合全网最新影视资源，电视剧全集、电影、综艺、纪录片一网打尽。',
  },
  {
    id: 'f4',
    icon: 'ri-shield-check-line',
    title: '安全观影',
    desc: '最新影视资源来源合规审核，播放环境纯净无广告植入，让你安心享受高清免费在线观看。',
  },
];

export const appData = {
  title: '随时随地，追剧不设限',
  subtitle: '玫瑰视频移动端',
  desc: '玫瑰视频适配手机与平板全平台，91视频网站和久久视频的全部内容同步移动端。在通勤途中、午休间隙，随时随地打开浏览器即可高清免费在线观看电视剧全集和电影大全，与桌面端同样流畅的不缓冲体验。无需下载APP，浏览器访问即用。',
  features: ['全平台适配', '流量优化模式', '夜间观影主题', '离线收藏功能'],
  image: 'https://readdy.ai/api/search-image?query=Smartphone%20displaying%20movie%20streaming%20interface%20on%20screen%2C%20held%20in%20hand%2C%20dark%20cinematic%20UI%20design%2C%20warm%20ambient%20background%2C%20modern%20mobile%20entertainment%20concept%2C%20clean%20minimal%20composition%2C%20soft%20lighting&width=600&height=800&seq=rose-app-01&orientation=portrait',
};

export const aboutData = {
  title: '关于玫瑰视频',
  sections: [
    {
      subtitle: '平台定位',
      content: '玫瑰视频是一个聚合91视频、91视频网站、久久视频、91在线视频等优质影视资源的高清在线观看平台。我们致力于为广大影视爱好者提供电视剧全集和电影大全的一站式浏览体验，让每一位用户都能享受不缓冲、高清免费的流畅观影服务。',
    },
    {
      subtitle: '内容生态',
      content: '平台每日更新最新影视资源，涵盖热门剧集、院线大片、经典老片、纪录片、综艺节目等多种类型。通过智能推荐算法和人工精选相结合的方式，帮助用户在海量内容中快速发现感兴趣的作品。',
    },
    {
      subtitle: '技术保障',
      content: '玫瑰视频自建流媒体分发网络，在全国范围内部署加速节点，配合智能码率自适应技术，确保不同网络环境下的用户都能获得不缓冲的顺畅播放体验。高清免费在线观看是我们的核心承诺。',
    },
    {
      subtitle: '发展愿景',
      content: '我们希望通过持续的技术创新和内容深耕，将玫瑰视频打造为中文互联网上最值得信赖的影视聚合平台。让好内容被发现，让观影更简单。',
    },
  ],
};

export const updatesData = [
  {
    id: 'u1',
    date: '2026-07-30',
    title: '平台播放器升级至V3.2版本',
    desc: '91在线视频播放器完成新一轮技术迭代，新增HDR色彩增强和空间音频支持，观影沉浸感大幅提升。',
    tag: '技术升级',
  },
  {
    id: 'u2',
    date: '2026-07-28',
    title: '电影大全新增500+经典影片',
    desc: '电影大全专区本周新增500余部经典影片，涵盖港片黄金年代、好莱坞经典、欧洲艺术电影等多个系列，全部高清修复版。',
    tag: '内容更新',
  },
  {
    id: 'u3',
    date: '2026-07-25',
    title: '久久视频暑期观影季活动上线',
    desc: '久久视频推出暑期特别策划，精选100部高分影片组成暑期观影清单，每天推荐一部必看佳作，陪你度过炎炎夏日。',
    tag: '活动',
  },
  {
    id: 'u4',
    date: '2026-07-22',
    title: '91视频网站移动端体验优化',
    desc: '针对移动端用户反馈进行了全面优化，加载速度提升40%，流量消耗降低25%，手机观影更加省心。',
    tag: '体验优化',
  },
  {
    id: 'u5',
    date: '2026-07-18',
    title: '最新影视七月片单完整发布',
    desc: '最新影视七月完整片单上线，涵盖20部热播剧集和30部口碑电影，电视剧全集持续追更中，不容错过。',
    tag: '片单发布',
  },
  {
    id: 'u6',
    date: '2026-07-15',
    title: '平台内容安全审核机制全面升级',
    desc: '进一步加强内容合规审核，引入AI+人工双重审核体系，保障平台所有资源安全可靠，高清免费在线观看更放心。',
    tag: '平台公告',
  },
  {
    id: 'u7',
    date: '2026-07-10',
    title: '玫瑰视频用户突破新里程碑',
    desc: '感谢每一位用户的支持与信任，我们将继续以不缓冲的流畅体验和海量最新影视资源回馈大家的厚爱。',
    tag: '里程碑',
  },
];

export const indexData = [
  { id: 'i1', title: '热门剧集', icon: 'ri-tv-2-line', count: '128部', desc: '91视频网站热播电视剧全集' },
  { id: 'i2', title: '动作电影', icon: 'ri-emotion-line', count: '256部', desc: '高燃动作大片高清合集' },
  { id: 'i3', title: '悬疑推理', icon: 'ri-search-eye-line', count: '183部', desc: '烧脑悬疑电影大全' },
  { id: 'i4', title: '喜剧天地', icon: 'ri-emotion-happy-line', count: '142部', desc: '爆笑喜剧电影不缓冲看' },
  { id: 'i5', title: '科幻世界', icon: 'ri-rocket-line', count: '97部', desc: '科幻巨制久久视频专区' },
  { id: 'i6', title: '爱情文艺', icon: 'ri-heart-line', count: '165部', desc: '浪漫爱情电影全集在线' },
  { id: 'i7', title: '纪录大片', icon: 'ri-earth-line', count: '210部', desc: '精品纪录片高清免费' },
  { id: 'i8', title: '动漫番剧', icon: 'ri-ghost-line', count: '340部', desc: '热门动漫91在线视频' },
  { id: 'i9', title: '综艺娱乐', icon: 'ri-music-line', count: '89部', desc: '最新综艺节目同步更新' },
];

export const mediaData = [
  {
    id: 'm1',
    title: '《暗夜追踪》——本季最燃悬疑剧',
    image: 'https://readdy.ai/api/search-image?query=Dark%20mystery%20thriller%20film%20scene%2C%20rainy%20night%20city%20street%2C%20detective%20silhouette%2C%20neon%20reflections%2C%20cinematic%20lighting%2C%20film%20noir%20aesthetic%2C%20suspenseful%20atmosphere%2C%20professional%20cinematography&width=640&height=360&seq=rose-media-01&orientation=landscape',
    duration: '45:32',
    views: '128万',
    tag: '悬疑',
  },
  {
    id: 'm2',
    title: '《夏日恋曲》——治愈系都市爱情',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20summer%20scene%20with%20couple%20walking%20on%20beach%20at%20sunset%2C%20warm%20golden%20light%2C%20cinematic%20color%20grading%2C%20soft%20focus%2C%20dreamy%20atmosphere%2C%20film%20quality&width=640&height=360&seq=rose-media-02&orientation=landscape',
    duration: '38:15',
    views: '96万',
    tag: '爱情',
  },
  {
    id: 'm3',
    title: '《星际征途》——国产科幻新标杆',
    image: 'https://readdy.ai/api/search-image?query=Epic%20science%20fiction%20space%20scene%2C%20massive%20spaceship%20in%20deep%20space%2C%20stars%20and%20nebula%20background%2C%20cinematic%20visual%20effects%2C%20dramatic%20lighting%2C%20film%20quality%20rendering&width=640&height=360&seq=rose-media-03&orientation=landscape',
    duration: '52:08',
    views: '156万',
    tag: '科幻',
  },
  {
    id: 'm4',
    title: '《江湖故人》——古装武侠巨制',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20film%20scene%2C%20ancient%20Chinese%20architecture%20in%20mist%2C%20swordsman%20silhouette%2C%20bamboo%20forest%2C%20atmospheric%20fog%2C%20cinematic%20wuxia%20aesthetic%2C%20epic%20composition&width=640&height=360&seq=rose-media-04&orientation=landscape',
    duration: '48:40',
    views: '203万',
    tag: '武侠',
  },
  {
    id: 'm5',
    title: '《城市探险家》——高分纪录片',
    image: 'https://readdy.ai/api/search-image?query=Urban%20exploration%20documentary%20scene%2C%20abandoned%20building%20with%20natural%20light%20streaming%20through%20windows%2C%20cinematic%20composition%2C%20rich%20textures%2C%20atmospheric%20mood%2C%20film%20quality&width=640&height=360&seq=rose-media-05&orientation=landscape',
    duration: '62:20',
    views: '75万',
    tag: '纪录',
  },
];

export const rankingData = [
  {
    id: 'r1',
    rank: 1,
    title: '暗夜追踪',
    type: '电视剧',
    heat: '热度 1286万',
    trend: 'up',
    desc: '91视频网站悬疑剧榜首，持续霸榜三周',
  },
  {
    id: 'r2',
    rank: 2,
    title: '夏日恋曲',
    type: '电视剧',
    heat: '热度 1102万',
    trend: 'up',
    desc: '久久视频都市爱情剧口碑黑马',
  },
  {
    id: 'r3',
    rank: 3,
    title: '江湖故人',
    type: '电影',
    heat: '热度 987万',
    trend: 'up',
    desc: '最新影视武侠片单日播放量破纪录',
  },
  {
    id: 'r4',
    rank: 4,
    title: '星际征途',
    type: '电影',
    heat: '热度 865万',
    trend: 'steady',
    desc: '电影大全科幻专区长期热门',
  },
  {
    id: 'r5',
    rank: 5,
    title: '欢乐一家人',
    type: '综艺',
    heat: '热度 742万',
    trend: 'down',
    desc: '91在线视频综艺频道热议话题',
  },
];

export const faqData = [
  {
    id: 'faq1',
    q: '玫瑰视频是否需要注册才能观看？',
    a: '不需要。玫瑰视频所有内容均支持高清免费在线观看，无需注册、无需登录，打开即看。91视频网站和久久视频的所有资源都面向全网用户开放。',
  },
  {
    id: 'faq2',
    q: '为什么有时播放会卡顿？如何实现不缓冲？',
    a: '91在线视频采用智能码率自适应技术，通常情况下可自动匹配最佳画质实现流畅播放。如遇卡顿，建议检查当前网络状态，或手动切换至较低清晰度。我们持续优化全国CDN节点部署，全力保障不缓冲体验。',
  },
  {
    id: 'faq3',
    q: '玫瑰视频的电视剧全集更新频率是怎样的？',
    a: '最新影视资源每日更新，热门剧集通常在播出后2小时内同步上线。电视剧全集持续追更至完结，你可以通过追更日历功能了解各剧集更新节奏。',
  },
  {
    id: 'faq4',
    q: '支持哪些设备观看？有没有APP？',
    a: '玫瑰视频支持所有主流浏览器访问，包括桌面端（Windows/Mac）和移动端（iOS/Android）。全平台自适应设计，无需下载APP，浏览器直接访问即可享受高清在线观看体验。',
  },
  {
    id: 'faq5',
    q: '电影大全的资源是否正版？',
    a: '玫瑰视频平台上的资源来自合规合作渠道和公开网络资源聚合，我们严格遵守相关法律法规，并设有专门的内容审核团队对所有资源进行合规性筛查。',
  },
  {
    id: 'faq6',
    q: '如何向玫瑰视频推荐影片或提交内容合作？',
    a: '欢迎通过平台的投稿与合作渠道与我们联系。你可以在联系我们模块找到详细联系方式，我们的内容团队会在3个工作日内回复你的建议或合作意向。',
  },
];

export const footerPartners = [
  { name: '合作伙伴A' },
  { name: '合作伙伴B' },
  { name: '合作伙伴C' },
  { name: '合作伙伴D' },
  { name: '合作伙伴E' },
  { name: '合作伙伴F' },
];